<template>
  <div class="waveMain">
    <svg viewBox="0 0 100 20">
      <defs>
        <filter id="goo">
          <feGaussianBlur in="SourceGraphic" stdDeviation="1" result="blur" />
          <feColorMatrix in="blur" mode="matrix" values="
          1 0 0 0 0
          0 1 0 0 0
          0 0 1 0 0
          0 0 0 13 -9" result="goo" />
          <xfeBlend in="SourceGraphic" in2="goo" />
        </filter>
        <path id="wave"
          d="M 0,10 C 30,10 30,15 60,15 90,15 90,10 120,10 150,10 150,15 180,15 210,15 210,10 240,10 v 100 h -240 z" />
      </defs>

      <use id="wave3" class="wave" xlink:href="#wave" x="0" :y="y"></use>
      <use id="wave2" class="wave" xlink:href="#wave" x="0" :y="y+1"></use>
    </svg>
  </div>
</template>

<script>
export default {
  props: ['y']

}
</script>

<style lang="less" scoped>
.waveMain {
  width:100%;
  position: absolute;
  bottom: 0px;
}
.waveMain div {
  background-color: var(--col-deepblue);
  margin: -5px 0px 0px 0px;
  padding:0px;
  color: #fff;
  text-align:center;
}
svg {
  width:100%;
  overflow:visible;
}

.wave {
  animation: wave 2s linear;
  animation-iteration-count:infinite;
  fill: #4478e3;
}

#wave2 {
  animation-duration: 2s;
  animation-direction: reverse;
  opacity: .6
}
#wave3 {
  animation-duration: 3s;
  opacity:.3;
}
@keyframes wave {
  to {transform: translateX(-100%);}
}

</style>
